import { api } from "./api";

/** Auth / User */
export const signIn = async (data) => {
    return await api({
        endpoint: "authentication/token/",
        method: "POST",
        withAuth: false,
        data,
    });
};

export const signUp = async (data) => {
    return await api({
        endpoint: "accounts/signup/",
        method: "POST",
        withAuth: false,
        data,
    });
};

export const verifyToken = async (data) => {
    return await api({
        endpoint: "authentication/token/verify/",
        method: "POST",
        withAuth: true,
        data,
    });
};

export const recoverPass = async (data) => {
    return await api({
        endpoint: "accounts/password-reset/",
        method: "POST",
        withAuth: false,
        data
    })
}

export const resetPass = async (data) => {
    return await api({
        endpoint: "accounts/change-password/",
        method: "POST",
        withAuth: false,
        data
    })
}

export const getMe = async (data) => {
    return await api({
        endpoint: "authentication/token/me/",
        method: "GET",
        withAuth: true,
        data,
    });
};

export const getPermissions = async () => {
    return await api({
        endpoint: "authentication/permissions/",
        method: "GET",
        withAuth: true,
    });
};

export const getCompany = async (data) => {
    return await api({
        endpoint: `empresa/${data.id}/`,
        method: "GET",
        withAuth: true,
        data,
    });
};

export const getMyCompany = async (id) => {
    return await api({
        endpoint: "empresa/minha/",
        method: "GET",
        withAuth: true,
    });
};

export const logout = async () => {
    return await api({
        endpoint: "authentication/logout/",
        method: "POST",
    });
};

export const updateUser = async (data, user) => {
    return await api({
        endpoint: `accounts/users/${user}/`,
        method: "PUT",
        data,
    });
};

/** Nfe */
export const getNfeSumary = async (data = {}) => {
    return await api({
        endpoint: 'nfes/resumo/',
        method: 'GET',
        data,
        withAuth: true
    });
}

export const getNfeSummaryDetail = async (id) => {
    return await api({
        endpoint: `nfes/resumo/${id}/`,
        method: 'GET',
        withAuth: true
    });
}

export const deleteNfeResumo = async (id) => {
    return await api({
        endpoint: `nfes/${id}/`,
        withAuth: true,
        method: 'DELETE'
    })
}

export const getNfe = async (data = {}) => {
    return await api({
        endpoint: 'nfes/',
        method: 'GET',
        data,
        withAuth: true
    });
}

export const getNfeDetail = async (id) => {
    return await api({
        endpoint: `nfes/${id}/`,
        withAuth: true,
    })
}

export const deleteNfe = async (id) => {
    return await api({
        endpoint: `nfes/${id}/`,
        withAuth: true,
        method: 'DELETE'
    })
}

export const getNfeAnalisesFaturamento = async (data) => {
    return await api({
        endpoint: 'nfes/analises-faturamento/',
        withAuth: true,
        data,
    })
}

export const getNfeAnalisesFaturamentoMes = async (data) => {
    return await api({
        endpoint: 'nfes/analises-faturamento-mes/',
        withAuth: true,
        data,
    })
}

export const getNfeAnalisesProdutos = async (data) => {
    return await api({
        endpoint: 'nfes/analises-produdos/',
        withAuth: true,
        data,
    })
}

export const getDanfeDownload = async (id) => {
    return await api({
        endpoint: `nfes/gerar-danfe/${id}/`,
        method: 'GET',
        withAuth: true,
    })
}

export const sendNfeZip = async (data = {}) => {
    return await api({
        endpoint: 'nfes/processar-lote/',
        method: 'POST',
        data,
        withAuth: true,
        withAttachment: true,
    });
}

export const manifestNfe = async (id, data) => {
    return await api({
        endpoint: `nfes/resumo/${id}/manifesto/`,
        method: 'POST',
        data,
        withAuth: true,
    });
};

/** Empresa */
export const getEmpresaFiliallDetail = async (id) => {
    return await api({
        endpoint: `empresa/${id}/`,
        method: 'GET',
        withAuth: true,
    })
}

export const createEmpresa = async (data) => {
    return await api({
        endpoint: `empresas/`,
        method: 'POST',
        data,
        withAuth: true,
        withAttachment: true,
    });
}

export const updateEmpresa = async (data, user) => {
    return await api({
        endpoint: `empresa/${user}/`,
        method: 'PATCH',
        data,
        withAuth: true,
        withAttachment: true,
    });
}

export const deleteEmpresa = async (id) => {
    return await api({
        endpoint: `empresa/${id}/`,
        withAuth: true,
        method: 'DELETE'
    })
}

/** Filial */
export const getFiliais = async (data) => {
    return await api({
        endpoint: 'empresas/',
        method: 'GET',
        data,
        withAuth: true,
    })
}

/** Produtos */
export const getProdutos = async (data) => {
    return await api({
        endpoint: 'nfes/produtos/',
        method: 'GET',
        data,
        withAuth: true,
    })
}

/** Fornecedores */
export const getFornecedor = async (data) => {
    return await api({
        endpoint: 'nfes/forncedor/',
        method: 'GET',
        data,
        withAuth: true,
    })
}

export const getFornecedorDetail = async (id) => {
    return await api({
        endpoint: `nfes/forncedor/detalhes/${id}/`,
        method: 'GET',
        withAuth: true,
    })
}

/** Apex */
export const getCustoMedioFornecedor = async (ano_inicio, ano_fim, empresa_id = null) => {
    const params = new URLSearchParams();
    if (ano_inicio) params.append("ano_inicio", ano_inicio);
    if (ano_fim) params.append("ano_fim", ano_fim);
    if (empresa_id) params.append("empresa_id", empresa_id);
    const queryString = params.toString() ? `?${params.toString()}` : "";
    return await api({ endpoint: `apexcharts/custo-medio-fornecedor/${queryString}`, method: "GET", withAuth: true });
};

export const getParticipacaoFornecedores = async (ano_inicio, ano_fim, empresa_id = null) => {
    const params = new URLSearchParams();
    if (ano_inicio) params.append("ano_inicio", ano_inicio);
    if (ano_fim) params.append("ano_fim", ano_fim);
    if (empresa_id) params.append("empresa_id", empresa_id);
    const queryString = params.toString() ? `?${params.toString()}` : "";
    return await api({ endpoint: `apexcharts/participacao-fornecedores/${queryString}`, method: "GET", withAuth: true });
};

export const getConcentracaoProdutos = async (percentual_alvo, ano_inicio, ano_fim, empresa_id = null) => {
    const params = new URLSearchParams();
    if (percentual_alvo) params.append("percentual_alvo", percentual_alvo);
    if (ano_inicio) params.append("ano_inicio", ano_inicio);
    if (ano_fim) params.append("ano_fim", ano_fim);
    if (empresa_id) params.append("empresa_id", empresa_id);
    const queryString = params.toString() ? `?${params.toString()}` : "";
    return await api({ endpoint: `apexcharts/concentracao-produtos/${queryString}`, method: "GET", withAuth: true });
};

export const getFrequenciaCompras = async (mes_ou_semana, ano_inicio, ano_fim, empresa_id = null) => {
    const params = new URLSearchParams();
    if (mes_ou_semana) params.append("mes_ou_semana", mes_ou_semana);
    if (ano_inicio) params.append("ano_inicio", ano_inicio);
    if (ano_fim) params.append("ano_fim", ano_fim);
    if (empresa_id) params.append("empresa_id", empresa_id);
    const queryString = params.toString() ? `?${params.toString()}` : "";
    return await api({ endpoint: `apexcharts/frequencia-compras/${queryString}`, method: "GET", withAuth: true });
};

export const getEmpresasAllNube = async () => {
    return await api({ endpoint: "empresa/allnube/", method: "GET", withAuth: true });
};

/** Categorias */
export const getCategorias = async () => {
    return await api({
        endpoint: `categorias/`,
        method: 'GET',
        withAuth: true,
    })
}

/** Funcionários */
export const getFuncionarios = async (params = {}) => {
    return await api({
        endpoint: 'funcionarios/',
        method: 'GET',
        data: params,
        withAuth: true,
    })
}

export const createFuncionario = async (data) => {
    return await api({
        endpoint: 'funcionarios/',
        method: 'POST',
        data,
        withAuth: true,
    })
}

export const updateFuncionario = async (id, data) => {
    return await api({
        endpoint: `funcionario/${id}/`,
        method: 'PATCH',
        data,
        withAuth: true,
    })
}

export const deleteFuncionario = async (id) => {
    return await api({
        endpoint: `funcionario/${id}/`,
        method: 'DELETE',
        withAuth: true,
    })
}

/** Superadmin - Empresas */
export const getEmpresas = async (params = {}) => {
    return await api({
        endpoint: 'empresas/',
        method: 'GET',
        data: params,
        withAuth: true,
    })
}

export const getEmpresaDetail = async (id) => {
    return await api({
        endpoint: `empresa/${id}/`,
        method: 'GET',
        withAuth: true,
    })
}

export const getSistemas = async () => {
    return await api({
        endpoint: 'sistemas/',
        method: 'GET',
        withAuth: true,
    })
}

export const getCategoriaEmpresas = async () => {
    return await api({
        endpoint: 'categorias/',
        method: 'GET',
        withAuth: true,
    })
}

/** Superadmin - Usuários */
export const getUsuarios = async (params = {}) => {
    return await api({
        endpoint: 'authentication/users/',
        method: 'GET',
        data: params,
        withAuth: true,
    })
}

export const createUsuario = async (data) => {
    return await api({
        endpoint: 'admin/users/',
        method: 'POST',
        data,
        withAuth: true,
    })
}

export const updateUsuario = async (id, data) => {
    return await api({
        endpoint: `admin/users/${id}/`,
        method: 'PUT',
        data,
        withAuth: true,
    })
}